import { RequestStatus } from "@/features/applications/model";
export var PaymentType;
(function (PaymentType) {
    PaymentType["CHECK"] = "CHECK";
    PaymentType["MONEY_ORDER"] = "MONEY_ORDER";
    PaymentType["NONE"] = "NONE";
})(PaymentType || (PaymentType = {}));
export const statusTransitions = {
    // For now, only admins can change status at all
    [RequestStatus.NEW]: [RequestStatus.DOCS_REQUIRED, RequestStatus.NOTARY_REQUIRED, RequestStatus.READY_TO_SUBMIT, RequestStatus.CANCELLED],
    [RequestStatus.DOCS_REQUIRED]: [RequestStatus.NOTARY_REQUIRED, RequestStatus.READY_TO_SUBMIT, RequestStatus.CANCELLED],
    [RequestStatus.NOTARY_REQUIRED]: [RequestStatus.READY_TO_SUBMIT, RequestStatus.CANCELLED],
    [RequestStatus.READY_TO_SUBMIT]: [RequestStatus.SUBMITTED, RequestStatus.CANCELLED],
    [RequestStatus.SUBMITTED]: [RequestStatus.APPROVED, RequestStatus.REJECTED, RequestStatus.CANCELLED],
    [RequestStatus.APPROVED]: [RequestStatus.DELIVERED, RequestStatus.CANCELLED],
    [RequestStatus.REJECTED]: [RequestStatus.DOCS_REQUIRED, RequestStatus.NOTARY_REQUIRED, RequestStatus.READY_TO_SUBMIT, RequestStatus.CANCELLED],
    [RequestStatus.DELIVERED]: [RequestStatus.CANCELLED],
    [RequestStatus.CANCELLED]: [RequestStatus.NEW],
};
